import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    color: false
}


const colorSlice = createSlice({
    name: 'colorSlice',
    initialState: initialState,
    reducers: {
        updateColor(state, action) {
            state.color = action.payload;
        },

    },
});

export const { updateColor } = colorSlice.actions;

export default colorSlice.reducer;
